export default __webpack_public_path__ + "static/media/login.4bb83dd7.png";